const EDIT_PROFILE = {
	TITLE: "Editar Perfil",
	NAME: "Nome",
	EMAIL: "E-mail",
	ABOUT: "Sobre",
	BIO_PLACEHOLDER: "Formado em Ciência da Computação pela Universidade Federal Fluminense, possui experiência em Inteligência Artificial.",
	CONTACTS: "Contatos:",
	ADD_NEW_CONTACT: "Novo contato",
	ADD_FINISHED: "Adicionar",
	SAVE_BTN: "Salvar",
	NONE_CONTACT: "Nenhum contato cadastrado",
	MANDATORY_FIELD: "Campo obrigatório",
	UPDATING: "Atualizando...",
	UPDATE_SUCCESS: "Perfil atualizado com sucesso",
	UPDATE_ERROR: "Erro ao atualizar perfil. Tente novamente!"
};

export default EDIT_PROFILE;